module.exports = __webpack_public_path__ + "img/banner.6ca096e5.jpg";